<template>
  <component
    :is="currentLayout"
    @tab-change="activeTab = $event"
  >
    <template #default>
      <component :is="currentSplash" v-if="activePage === 'splash'" />
      <component :is="currentBooking" v-else-if="activePage === 'booking'" :active-tab="activeTab" />
      <component :is="currentOrders" v-else-if="activePage === 'orders_history'" />
    </template>
    <template #dialogs>
      <Auth               v-if="$store.state.loginDialogStatus"/>
      <SubmitBookingPage  v-if="$store.state.bookingDialogStatus"/>
      <BookingSelectEmploye v-if="$store.state.bookingSelectEmployeDialogStatus"/>
      <BookingSelectService v-if="$store.state.bookingSelectServiceDialogStatus"/>
      <BookingSelectInfo  v-if="$store.state.bookingSelectInfoDialogStatus"/>
      <Profile            v-if="$store.state.showProfileDialogStatus"/>
    </template>
  </component>
</template>

<script>
// صفحات پیش‌فرض
import DefaultSplash  from './pages/splash.vue';
import DefaultBooking from './pages/booking.vue';
import DefaultOrders  from './pages/orders.vue';
import DefaultLayout  from './themes/default/Layout.vue';

// dialogs
import Auth               from './components/auth.vue';
import Profile            from './components/Profile.vue';
import SubmitBookingPage  from './components/submit_booking.vue';
import BookingSelectEmploye from './components/booking_select_employe.vue';
import BookingSelectService from './components/booking_select_service.vue';
import BookingSelectInfo  from './components/booking_select_info.vue';

export default {
  name: 'App',
  components: {
    Auth, Profile, SubmitBookingPage,
    BookingSelectEmploye, BookingSelectService, BookingSelectInfo,
    DefaultSplash, DefaultBooking, DefaultOrders, DefaultLayout,
  },
  data: () => ({ activeTab: 'services' }),
  computed: {
    activePage() { return this.$store.state.activePage; },
    theme()      { return this.$store.state.currentTheme; },
    currentLayout()  { return this.theme?.Layout  ?? DefaultLayout; },
    currentSplash()  { return this.theme?.pages?.Splash  ?? DefaultSplash; },
    currentBooking() { return this.theme?.pages?.Booking ?? DefaultBooking; },
    currentOrders()  { return this.theme?.pages?.Orders  ?? DefaultOrders; },
  },
  async mounted() {
    await this.$store.dispatch('fetchAuthToken');
    await this.$store.dispatch('fetchBaseData');
  },
};
</script>

<style>
.Vue-Toastification__toast-body {
  font-family: 'iransans' !important;
  direction: rtl;
}
</style>
